<app-dashboard-stats-card [title]="'Rejected'" subtitle="Packages that contain a 'Rejected' response."
                          [count]="getPackageCount()" [routerLink]="'/my-packages'" [queryParams]="{ open: true, open_o: 'is', rejected: true, rejected_o: 'is' }" />
